import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const STEPS = [
  { n: 1, label: 'Resume' },
  { n: 2, label: 'Job Info' },
  { n: 3, label: 'Options' },
  { n: 4, label: 'Review' },
  { n: 5, label: 'Results' },
];

interface StepHeaderProps {
  currentStep: number;
}

export function StepHeader({ currentStep }: StepHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between relative">
        {/* connector line */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-border z-0" />
        {STEPS.map(({ n, label }) => {
          const done = n < currentStep;
          const active = n === currentStep;
          return (
            <div key={n} className="flex flex-col items-center z-10 gap-1.5">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm border-2 transition-all ${
                  done
                    ? 'bg-green-500 border-green-500 text-white'
                    : active
                    ? 'bg-primary border-primary text-white shadow-md'
                    : 'bg-background border-border text-muted-foreground'
                }`}
              >
                {done ? <CheckCircle2 className="w-5 h-5" /> : n}
              </div>
              <span
                className={`text-xs font-medium whitespace-nowrap ${
                  active ? 'text-primary' : done ? 'text-green-600' : 'text-muted-foreground'
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
